const types = [
  {
    text: 'טריוויה',
    typeValue: 'trivia',
    id: '66549a8acd6f78c962fc12c6',
  },
  {
    text: 'התאמת זוגות',
    typeValue: 'matchingPairs',
    id: '66549a8acd6f78c962fc12d3',
  },
  {
    text: 'הקלדה',
    typeValue: 'typing',
    id: '66549a8acd6f78c962fc12cb',
  },
  {
    text: 'ציר זמן',
    typeValue: 'timeline',
    id: '66549a8acd6f78c962fc12ce',
  },
  {
    text: 'סימון מיקום',
    typeValue: 'mark',
    id: '66549a8acd6f78c962fc12cf',
  },
  {
    text: 'סקר',
    typeValue: 'survey',
    id: '66549a8acd6f78c962fc12c7',
  },
  {
    text: 'בחירה מרובה',
    typeValue: 'multiselect',
    id: '66549a8acd6f78c962fc12d1',
  },

  {
    text: 'טריוויה תמונות',
    typeValue: 'ans_images',
    id: '66549a8acd6f78c962fc12c9',
  },
  {
    text: 'טריוויה מתמטיקה',
    typeValue: 'math_trivia',
    id: '66549a8acd6f78c962fc12d0',
  },
  {
    text: 'משחקון',
    typeValue: 'game',
    id: '66549a8acd6f78c962fc12ca',
  },
  {
    text: 'דיון',
    typeValue: 'discussion',
    id: '66549a8acd6f78c962fc12cd',
  },
  {
    text: 'מדיה',
    typeValue: 'media',
    id: '66549a8acd6f78c962fc12c8',
  },
  {
    text: 'תמונה וכותרת',
    typeValue: 'subject',
    id: '66549a8acd6f78c962fc12cc',
  },
  {
    typeValue: 'wordsCloud',
    text: 'ענן מילים',
    id: '66549a8acd6f78c962fc12d2',
  },
]
export const typesKeys = types.reduce((acc, item) => {
  acc[item.typeValue] = item.text
  return acc
}, {})

export default types
